document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".mySwiper_sliderhm", {
    slidesPerView: 1, spaceBetween: 30, loop: true,
    // autoplay: { delay: 4000, disableOnInteraction: false },
    pagination: { el: ".swiper-pagination", clickable: true },
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev"}
  });

  new Swiper(".Swipertestimonial_slider_cv", {
    slidesPerView: 1,centeredSlides: true,loop: true,
    // autoplay: { delay: 5000, disableOnInteraction: false },
    pagination: { el: ".swiper-pagination", clickable: true },
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
  });

  new Swiper(".swiper-containernew", {
    slidesPerView: 'auto', loop: true, centeredSlides: true, loopAdditionalSlides: 5, spaceBetween: 70,
    pagination: { el: ".swiper-pagination", clickable: true },
    speed: 6000,
    autoplay: { delay: 0, enabled: true },
    breakpoints: {
      320: { slidesPerView: 'auto' },
      768: { slidesPerView: 'auto' }
    }
  }); 

  new Swiper('.swiper-initializeinsta', {
    slidesPerView: 3.5, spaceBetween: 41,
    breakpoints: {
      1280: { slidesPerView: 3.4, spaceBetween: 41 },
      1024: { slidesPerView: 2.4, spaceBetween: 32 },
      768: { slidesPerView: 2.2, spaceBetween: 32 },
      320: { slidesPerView: 1.2, spaceBetween: 32,slidesOffsetAfter: 40 }
    },
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
    pagination: { el: '.swiper-pagination', clickable: true }
  });  

  class ShopCategory extends HTMLElement{
    constructor(){
      super();

      new Swiper('.shop_category__tabs_interior.swiper', {
          slidesPerView: 'auto',
          spaceBetween: 0
      }); 

      new Swiper('.shop_by_category__selected__grid.swiper', {
        slidesPerView: 1.2, spaceBetween: 24,
        breakpoints: { 1280: { slidesPerView: 4.2, spaceBetween: 32 }, 750: { slidesPerView: 2.2, spaceBetween: 25 } },
        navigation: { nextEl: '.slider-button--nexts', prevEl: '.slider-button--prevs' },
        pagination: { el: '.swiper-pagination', clickable: true }
      });

      this.selected_collection = this.querySelector('[data-current-link]').dataset.currentLink;
      document?.querySelector(`.shop_category__tabs a[href="${this.selected_collection}"]`)?.parentNode?.classList.add('active');

      this.querySelectorAll('.shop_category__linklists.acceptsdropdowns').forEach((el)=>{
        el.querySelector('.shop_category__link__name').addEventListener('click',(target)=>{
          target.preventDefault();
          if( target.target.closest('.acceptsdropdowns').classList.contains('active') ){
            target.target.closest('.acceptsdropdowns').classList.remove('active');
          }else{
            this.querySelectorAll('.shop_category__linklists.acceptsdropdowns').forEach((rm)=>{ rm.classList.remove('active'); });
            target.target.closest('.acceptsdropdowns').classList.add('active');
          } 
        });
        el.querySelectorAll('.shop_category__link__list li').forEach((tg)=>{
          tg.querySelector('a').addEventListener('click',(target)=>{
            target.preventDefault();
            this.EnableloaderInitialize();
            this.collectionRoute = target.target.closest('li').querySelector('a').getAttribute('href');
            this.routeCollectionHTML(this.collectionRoute);
          })
        });
      });
      this.querySelectorAll('.shop_category__linklists.singlenavherit').forEach((el)=>{
        el.querySelector('.shop_category__link__name a').addEventListener('click',(target)=>{
          target.preventDefault();
          this.EnableloaderInitialize();
          this.collectionRoute = target.target.closest('.shop_category__link__name').querySelector('a').getAttribute('href');
          this.routeCollectionHTML(this.collectionRoute);
        })
      });  
    }
    removeOthercategoryActive(){
      this.querySelectorAll('.shop_category__linklists.acceptsdropdowns').forEach((rm)=>{ rm.classList.remove('active'); rm.querySelectorAll('.shop_category__link__list li').forEach((tm)=>{ tm.classList.remove('active'); }) });
      this.querySelectorAll('.shop_category__linklists.singlenavherit').forEach((rm)=>{ rm.querySelector('.shop_category__link__name').classList.remove('active') });
    }
    EnableloaderInitialize(){
      this.querySelector('.shop_by_category__products_interior').classList.add('active');
      this.querySelector('.loading__change__apearance').classList.remove('hidden');
    }
    DisableloaderInitialize(){
      this.querySelector('.shop_by_category__products_interior').classList.remove('active');
      this.querySelector('.loading__change__apearance').classList.add('hidden');
    }    
    routeCollectionHTML(acceptedHandle){
      const targetContainer = document.querySelector('[js-update-category]');
      fetch(`${acceptedHandle}`)
        .then(response => response.text())
        .then(htmlString => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, 'text/html');
          const sectionEl = doc.querySelector('[js-collection-main]');
          if (!sectionEl || !sectionEl.dataset.sectionId) return;
          const sectionId = sectionEl.dataset.sectionId;
          const contentHtml = doc.querySelector(`[data-section-id="${sectionId}"]`)?.querySelector('[js-category-html]')?.innerHTML;
          if (!contentHtml) return;
          targetContainer.innerHTML = contentHtml;
        }).finally( fnl =>{
          new Swiper('.shop_by_category__selected__grid.swiper', {
            slidesPerView: 1.2, spaceBetween: 24,
            breakpoints: { 1280: { slidesPerView: 4.2, spaceBetween: 32 }, 750: { slidesPerView: 2.2, spaceBetween: 25 } },
            navigation: { nextEl: '.slider-button--nexts', prevEl: '.slider-button--prevs' },
            pagination: { el: '.swiper-pagination', clickable: true }
          });
          this.DisableloaderInitialize();this.removeOthercategoryActive();
          this.selected_collection = this.querySelector('[data-current-link]').dataset.currentLink;
          document?.querySelector(`.shop_category__tabs a[href="${this.selected_collection}"]`)?.parentNode?.classList.add('active');
          document?.querySelector(`.shop_category__tabs a[href="${this.selected_collection}"]`)?.parentNode?.classList.add('active');
        })
        .catch(err => {
          console.error("Drawer fetch error:", err);
        });      
    }
  }
  customElements.define('shop-by-category', ShopCategory);  
});